import { User, UserType } from "../../entities/User";
import { Action } from "../actions/All";
import { ActionType } from "../ActionTypes";
import { PresetObj } from "../../api-entities/PresetArea";

export interface UserStore {
	/**
	 * The current user.
	 */
	user: User;

	/**
	 * The current user's area presets.
	 */
	areaPresets?: PresetObj[];

	/**
	 * In dev mode all requests are sent with a token in the url query for authentication.
	 * This isn't need for live where cookies are used instead.
	 */
	token?: string;
}

/**
 * The state of the user store on app start up.
 */
export const initial: UserStore = {
	user: {
		type: UserType.Unknown
	}
};


export const userReducer = (state: UserStore = initial, action: Action): UserStore => {
	switch (action.type) {
		case ActionType.LOG_OUT: {
			return {
				...state,
				user: {
					type: UserType.Unknown
				}
			};
		}

		case ActionType.LOG_IN: {
			return {
				...state,
				user: action.user
			};
		}

		case ActionType.SET_USER_TOKEN: {
			return {
				...state,
				token: action.token
			};
		}

		case ActionType.SET_USER_PRESET_AREAS: {
			return {
				...state,
				areaPresets: action.areas
			};
		}

		default:
			return state;
	}
};
